/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entrylink1Inputs */

const en_entrylink1 = /** @type {(inputs: Entrylink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outside link`)
};

const de_entrylink1 = /** @type {(inputs: Entrylink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externer Link`)
};

/**
* | output |
* | --- |
* | "Outside link" |
*
* @param {Entrylink1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entrylink1 = /** @type {((inputs?: Entrylink1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrylink1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entrylink1(inputs)
	return de_entrylink1(inputs)
});
export { entrylink1 as "entryLink" }